<!--
@component
@deprecated REPTILE-1303
-->
<script lang="ts">
    import { untrack } from 'svelte';
    import type { Page } from '@shared/types/Tilelist.ts';
    import type { TileListInitialSession } from '@tilelist/application/core/TileListInitialSession.ts';
    import type { SelectionUpdate } from '@tilelist/application/ports/SelectionEvents.ts';
    import { injectWiring } from '@tilelist/application/wiring/TileListWiringContext.svelte.ts';

    /**
 *
 *
 *
 */

    const { initialSession }: { initialSession: TileListInitialSession } = $props();
    const wiring = injectWiring(['selectionEvents', 'eventsOutgoing', 'trackingService']);

    function checkpointData(rule: string, page: Page) {
        return { rule, page: { ...page }, historic: true };
    }

    function handleSelectionUpdate(update: SelectionUpdate): void {
        const url = update.selection.url;
        wiring.trackingService.trackUrl(url);
        if (!update.historic) {
            const page: Page = {
                ...(update.selection.page.sortOrder !== undefined
                    ? { sortiertnach: update.selection.page.sortOrder }
                    : {}),
                ...(update.selection.page.offset !== undefined ? { o: update.selection.page.offset } : {}),
                ...(update.selection.page.layout !== undefined ? { l: update.selection.page.layout } : {}),
                ...(update.selection.page.comparisonId !== undefined ? { c: update.selection.page.comparisonId } : {}),
            };
            wiring.eventsOutgoing.legacyHistory.push({
                topic: 'ftfind.dresonRule.resolve',
                data: checkpointData(update.selection.rule, page),
                url,
            });
        }
    }

    function subscribe() {
        wiring.eventsOutgoing.legacyHistory.merge({
            topic: 'ftfind.dresonRule.resolve',
            data: checkpointData(initialSession.page.context.rule, initialSession.page.page ?? {}),
        });
        return wiring.selectionEvents.onUpdate(handleSelectionUpdate);
    }

    $effect(() => {
        const selectionEvents = wiring.selectionEvents;
        const eventsOutgoing = wiring.eventsOutgoing;
        if (!selectionEvents || !eventsOutgoing) return;
        return untrack(subscribe);
    });
</script>
